import { createJSONStorage } from 'zustand/middleware';

const sessionStorageAdapter = {
	getItem: (name: string): string | null => sessionStorage.getItem(name),
	setItem: (name: string, value: string): void => sessionStorage.setItem(name, value),
	removeItem: (name: string): void => sessionStorage.removeItem(name),
};

export const createSessionStorage = () => createJSONStorage(() => sessionStorageAdapter);

export const serializeDates = <T extends Record<string, any>>(state: T, dateFields: (keyof T)[]): T => {
	const result = { ...state };

	dateFields.forEach((field) => {
		const value = state[field] as any;
		if (value instanceof Date) {
			(result[field] as any) = value.toISOString();
		}
	});

	return result;
};

export const deserializeDates = <T extends Record<string, any>>(
	state: T,
	dateFields: (keyof T)[],
	defaultValues: Partial<T> = {}
): T => {
	const result = { ...defaultValues, ...state };

	dateFields.forEach((field) => {
		const value = state[field];
		if (typeof value === 'string') {
			try {
				(result[field] as any) = new Date(value);
			} catch (e) {
				console.error(`Error parsing date field ${String(field)}:`, e);
				(result[field] as any) = defaultValues[field] ?? null;
			}
		}
	});

	return result;
};

export const safeDeserialize = <T>(
	str: string,
	deserializeStateFn: (state: any) => any,
	defaultState: T
): { state: T } => {
	try {
		const parsed = JSON.parse(str);
		if (parsed.state) {
			return {
				...parsed,
				state: deserializeStateFn(parsed.state),
			};
		}
		return parsed;
	} catch (e) {
		console.error('Error deserializing state:', e);
		return { state: defaultState };
	}
};
